import React from 'react';

const SVG = ({
  fill = '#fff',
  width = '100%',
  height = '100%',
  className = 'sunSVG',
}) => (
  <svg
    viewBox="0 0 288 267.5"
    height={height}
    width={width}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M250.4,160.7c-8.6-8.1-17-14-25.1-18.4c7.9-4.6,16.1-10.8,24.4-18.9c-10.9-4.7-20.9-7.4-30.1-8.8
		c5.9-7.1,11.5-15.7,16.5-26.3c-11.8-0.6-22.1,0.2-31.2,2.1c3.1-8.7,5.4-18.7,6.4-30.4c-11.4,3.5-20.9,7.9-28.8,12.8
		c-0.1-9.3-1.4-19.6-4.5-31c-8.5,6.5-15.3,13.1-20.7,19.7c-2.9-8-7.2-16.4-13-25.2c-6.6,9.7-11.2,18.9-14.3,27.5
		c-5.7-7.1-13.1-14.3-22.4-21.2c-2.9,11.3-4.1,21.4-4.1,30.6c-7.8-4.7-17-8.9-28.1-12.2c1.1,11.8,3.5,21.9,6.7,30.6
		c-9-1.8-19.3-2.6-31.1-1.9c5.1,10.6,10.7,19.2,16.7,26.3c-9.1,1.4-18.9,4.2-29.6,8.8c8.4,8.2,16.6,14.4,24.7,19
		c-8,4.4-16.4,10.4-24.8,18.4c10.8,4.9,20.7,7.9,29.9,9.4c-6.1,6.9-11.9,15.5-17.1,26c11.8,0.9,22.1,0.3,31.2-1.4
		c-3.3,8.6-5.8,18.6-7.1,30.2c11.5-3.2,21-7.4,29-12.2c-0.1,9.3,1,19.6,3.8,31c9.3-6.8,16.7-13.8,22.4-20.8
		c3,8.5,7.4,17.6,13.7,27.1c7-10.3,11.8-20,14.8-29.1c6,7.4,13.9,14.8,23.9,21.9c2.7-11.3,3.7-21.5,3.4-30.6
		c7.9,4.5,17.2,8.5,28.3,11.6c-1.4-11.8-3.9-21.8-7.4-30.4c9.1,1.6,19.4,2.2,31.1,1.2c-5.3-10.5-11.1-19-17.3-25.9
		C230,168.5,239.8,165.5,250.4,160.7z M144.1,215.9c-39.8,0-72.1-32.3-72.1-72.1s32.3-72.1,72.1-72.1s72.1,32.3,72.1,72.1
		S183.9,215.9,144.1,215.9z"
      />
      <circle cx="144.3" cy="144" r="63.2" />
    </g>
  </svg>
);

export default SVG;
